<template>
  <div>
    <h1>Toegang</h1>

    <Alert :variant="alert.variant" :message="alert.message" v-if="alert.enabled" />

    <table class="table">
      <thead>
        <tr>
          <td>#</td>
          <!--<td>ID</td>-->
          <td>Token</td>
          <td>Actie(s)</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(jwt, i) in jwts" :key="i">
          <td>{{ i+1 }}</td>
          <!--<td>{{ jwt.jti }}</td>-->
          <td><textarea class="form-control" rows="5" v-model="jwt.encoded" disabled /></td>
          <td><button class="mb-1 btn btn-outline-red" @click="deleteToken(jwt.jti)">Verwijderen</button></td>
        </tr>
      </tbody>
    </table>

    <button class="mb-1 btn btn-primary" @click="postToken" v-if="allowNewKeys">Toevoegen</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

import Alert from './Alert'

export default {
  metaInfo: {
    title: 'Access'
  },
  components: {
    Alert: Alert
  },
  data () {
    return {
      alert: {
        enabled: true,
        variant: '',
        message: ''
      },
      jwts: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getTokens()
    })
  },
  methods: {
    getTokens: function () {
      axios
        .get(`${process.env.BACKEND_URL}/tokens`, {
          headers: {
            Authorization: `Bearer ${this.firebaseUser.ra}`
          }
        })
        .then(res => (this.jwts = res.data))
        .catch(err => console.log(err))
    },
    postToken: function () {
      axios
        .post(`${process.env.BACKEND_URL}/token`, {}, {
          headers: {
            Authorization: `Bearer ${this.firebaseUser.ra}`
          }
        })
        .then(() => {
          this.alert.enabled = true
          this.alert.variant = 'success'
          this.alert.message = 'de nieuwe token is toegevoegd.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
        .then(() => this.getTokens())
        .catch(err => {
          console.log(err)
          this.alert.enabled = true
          this.alert.variant = 'danger'
          this.alert.message = 'de nieuwe token kon niet worden toegevoegd. Probeer het later nog eens.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
    },
    deleteToken: function (jti) {
      axios
        .delete(`${process.env.BACKEND_URL}/token/${jti}`, {
          headers: {
            Authorization: `Bearer ${this.firebaseUser.ra}`
          }
        })
        .then(() => {
          this.alert.enabled = true
          this.alert.variant = 'success'
          this.alert.message = 'de token is verwijderd.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
        .then(() => this.getTokens())
        .catch(err => {
          console.log(err)
          this.alert.enabled = true
          this.alert.variant = 'danger'
          this.alert.message = 'de token kon niet worden verwijderd. Probeer het later nog eens.'
          setTimeout(() => { this.alert.enabled = false }, 5000)
        })
    }
  },
  computed: {
    ...mapState(['firebaseUser']),
    allowNewKeys: function () {
      return this.jwts.length < 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Access.vue